import React, { SVGAttributes } from "react";

// KOA-5857 — Lock glyph rendered next to immutable cells (PK / identity /
// autoincrement). Same .svg.tsx pattern other Kuika icons use; kept local
// to the table editor since no other consumer needs a lock today.
const LockSvg: React.FC<SVGAttributes<SVGSVGElement>> = (props: SVGAttributes<SVGSVGElement>): JSX.Element => (
  <svg width="10" height="12" viewBox="0 0 10 12" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M3 4.5V3a2 2 0 1 1 4 0v1.5"
      stroke="currentColor"
      strokeWidth="1.1"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <rect x="1.25" y="4.5" width="7.5" height="6.25" rx="1.25" stroke="currentColor" strokeWidth="1.1" fill="none" />
    <circle cx="5" cy="7.5" r="0.75" fill="currentColor" />
  </svg>
);

export default LockSvg;
